import Practitioners from './Paritionor'

export default Practitioners

